import mock from 'api/mock';

mock.onGet('/login/oauth/authorization/collective').reply(() => [200, '/callback/easyprojets']);
mock.onGet('/login/oauth/authorization/individual').reply(() => [200, '/callback/maretraite360']);
mock.onGet('/login/oauth/authorization/individual_transmission').reply(() => [200, '/callback/matransmission360']);

mock.onGet('/login/change-password/collective').reply(() => [
    200,
    'https://connect-recprj.ma-protectionsociale.fr/?ReturnUrl=/connect/authorize/callback?client_id=3bdd694e-8352-4735-9211-1ec507b3bda6'
]);

mock.onGet('/login/oauth/profile/collective').reply(() => {
    const oauth_profile = {
        vot: 'Kl.Cc',
        vtm: 'https://connect.ma-protectionsociale.fr/vot-trust-framework.html',
        auth_time: 1621333413,
        previous_auth_time: 1621281361,
        sub: 'c9c43d48-f9d8-4e50-98cd-324e3eb58af7',
        'axa-fr-salary-saving-internet-login': '00000000', // TODO remove for full esr
        'ais-fr-retirement-saving-customer-login': '00000000',
        'axa-fr-salary-saving-customer-id': 'a799df79-8275-41a5-aec9-a16160fc5ca5', // TODO remove for full esr
        'ais-fr-retirement-saving-customer-id': '000000000',
        'https://connect.axa.fr/individualOrProfessional.mainCustomerId': '0000',
        'https://connect.axa.fr/individualOrProfessional.customerId': '0000',
        preferred_username: 'collective@axa.fr',
        name: 'collective@axa.fr',
        given_name: 'Acon',
        family_name: 'MOCK'
    };
    const disabled_scopes = {
        disabled_scopes: {s2e: ['pi', 'arbitration', 'message']}
    };
    const alert_text_cutoff = {
        alert_text_cutoff: {
            en: {
                title: 'Your new personal employee savings space is now available!',
                message1:
                    'You can <bold>manage your savings and carry out all your employee savings operations</bold> rom your new personal space. Your login credentials have been sent to you by email.',
                message2: 'Your login credentials have been sent to you by email.',
                message3:
                    "While the history of your transactions and documents is being transferred to your new space, they remain accessible at any time on your previous space.<br/><sso scope='s2e' endpoint='/operations/consulteroperations' label='Access your employee savings history and documents'/><linkTag href='https://espace-salarie.axa-mon-epargne-entreprises.com' target=\"_blank\">Access your new personal space</linkTag>"
            },
            fr: {
                title: "Votre nouvel espace personnel d'épargne salariale est disponible !",
                message1:
                    "Vous pouvez <bold>gérer votre épargne et effectuer toutes vos opérations d'épargne salariale</bold>, depuis votre nouvel espace personnel.",
                message2: 'Vos identifiants ont été envoyés par e-mail.',
                message3:
                    "En attendant la mise à disposition de l'historique de vos opérations et de vos documents sur votre espace, ils restent accessibles à tout moment sur votre ancien espace.<br/><sso scope='s2e' endpoint='/operations/consulteroperations' label='Accéder à votre historique et documents d’épargne salariale'/><linkTag href='https://espace-salarie.axa-mon-epargne-entreprises.com' target=\"_blank\">Accéder à votre nouvel espace personnel</linkTag>"
            }
        }
    };
    return [200, {oauth_profile, ...disabled_scopes, ...alert_text_cutoff}];
});

mock.onGet('/login/oauth/profile/individual').reply(() => {
    const oauth_profile = {
        vot: 'Kl.Cc',
        vtm: 'https://connect.axa.fr/vot-trust-framework.html',
        auth_time: 1621413423,
        previous_auth_time: 1621339432,
        sub: '929000aa-8041-4e80-a840-0d5eccc20a1b',
        'https://connect.axa.fr/individualOrProfessional.mainCustomerId': '00000000',
        'axa-fr-salary-saving-internet-login': '00000000',
        'ais-fr-retirement-saving-customer-login': '00000000',
        'axa-fr-salary-saving-customer-id': 'a799df79-8275-41a5-aec9-a16160fc5ca5',
        'ais-fr-retirement-saving-customer-id': '000000000',
        preferred_username: '1789452',
        name: '1789452',
        gender: '1',
        given_name: 'INDIVIDUAL',
        family_name: 'MOCK'
    };

    return [200, {oauth_profile}];
});
mock.onGet('/login/oauth/profile/individual_transmission').reply(() => {
    const oauth_profile = {
        vot: 'Kl.Cc',
        vtm: 'https://connect.axa.fr/vot-trust-framework.html',
        auth_time: 1621413423,
        previous_auth_time: 1621339432,
        sub: '929000aa-8041-4e80-a840-0d5eccc20a1b',
        'https://connect.axa.fr/individualOrProfessional.mainCustomerId': '00000000',
        preferred_username: '1789452',
        name: '1789452',
        gender: '1',
        given_name: 'INDIVIDUAL_transmission',
        family_name: 'MOCK'
    };

    return [200, {oauth_profile}];
});

mock.onGet('/login/api-client/token/collective').reply(() => [200, 'OK']);
mock.onGet('/login/api-client/token/individual').reply(() => [200, 'OK']);
mock.onGet('/login/api-client/token/individual_transmission').reply(() => [200, 'OK']);

mock.onGet('/login/oauth/otp/collective').reply((config) => [200, `/authcallback?state=${config.params.state}`]);
mock.onGet('/login/oauth/otp/callback/collective').reply(() => [200, {has_validate_acon_otp: true}]);
